import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { PreviousVaccineModel } from '../../../models/consultation-process/previous-vaccine.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { NewVaccineAddedModel } from '../../../models/consultation-process/previous-vaccine.model';
import { Page } from '../../../models/list/page.model';
import { PreviousVaccineService } from '../../consultation-process/record-previous-vaccines/record-previous-vaccine.service';
import { ConsultationProcessService } from '../../consultation-process/consultation-process.service';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { AddVaccinationPopupComponent } from './add-vaccination-popup.component';

@Component({
    selector: 'record-vaccination-popup',
    templateUrl: 'record-vaccination-popup.component.html',
    providers: [PreviousVaccineService, ConsultationProcessService]
})

export class RecordPreviousVaccinePopupComponent implements OnInit {
    public appConstants = AppConstants;
    public newVaccineAdded: Array<NewVaccineAddedModel> = [];
    public dataRow: Array<PreviousVaccineModel> = []; // data for Complete history tab
    public coverDataRow: Array<PreviousVaccineModel> = []; // data for Current cover tab
    public page = new Page(); // paging for Complete history tab
    public coverPage = new Page(); // paging for Current cover tab
    public selectedTab = 0; // current selected tab
    public tabUpdate = [false, false]; // if true then call setPage to reload list
    dataMessage = {
        emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
        totalMessage: AppMessages.list.total // Footer total message
    };
    customClasses = AppConstants.table.footerClasses;

    constructor(public dialogService: DialogService,
        public consultationProcessService: ConsultationProcessService,
        public router: Router,
        public activeRouter: ActivatedRoute,
        public previousVaccineService: PreviousVaccineService,
        public dialogRef: MdDialogRef<RecordPreviousVaccinePopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.setPage({ offset: 0 });
        this.setCoverPage({ offset: 0 });
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            isShowAll: true,
            consultationId: this.data.id
        };

        this.previousVaccineService.getVaccineList(this.data.patientId, param).subscribe(
            (result) => {
                const data = result.json();
                this.dataRow = data['list'];
                this.page.totalElements = data['totalRecords'];
                this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
                this.tabUpdate[0] = false;
            }
        );
    }

    setCoverPage(pageInfo) {
        this.coverPage.pageNumber = pageInfo.offset;
        const param = {
            pageSize: this.coverPage.size,
            currentPage: this.coverPage.pageNumber + 1,
            isShowAll: false,
            consultationId: this.data.id
        };

        this.previousVaccineService.getVaccineList(this.data.patientId, param).subscribe(
            (result) => {
                const data = result.json();
                this.coverDataRow = data['list'];
                this.coverPage.totalElements = data['totalRecords'];
                this.coverPage.totalPages = Math.ceil(this.coverPage.totalElements / this.coverPage.size);
                this.tabUpdate[1] = false;
            }
        );
    }

    createNewVaccineDialog() {
        this.newVaccineAdded = [];
        const data = { id: this.data.id, patientId: this.data.patientId };
        this.dialogService.openComponentDialog(AddVaccinationPopupComponent, data, {
            'width': '80%'
        }).subscribe(result => {
            if (result) {
                this.setPage({ offset: 0 });
                this.setCoverPage({ offset: 0 });
            }
        });
    }

    onCheckCompletion(monthCoverLeft) {
        if (monthCoverLeft === 'incomplete course') {
            return true;
        }
        return false;
    }

    onRemoveItem(otherVaccineId) {
        this.previousVaccineService.removePreviousVaccine(this.data.id, otherVaccineId).subscribe(
            (result) => {
                if (result) {
                    this.setPage({ offset: 0 });
                }
            }
        );
    }

    submitData() {
        this.onCloseDialog();
        // this.consultationProcessService.moveToNextStep(this.data.id, ConsultationStep.RecordPreviousVaccines).subscribe(
        //     (result) => {
        //         if (result) {
        //         }
        //     }
        // );
    }

    onSelectedTabChange(event) {
        this.tabUpdate[this.selectedTab] = false;
        this.selectedTab = event.index;
        this.tabUpdate[this.selectedTab] = true;
        if (this.tabUpdate[this.selectedTab] === true) {
            if (this.selectedTab === 0) {
                this.setPage({ offset: 0 });
            } else {
                this.setCoverPage({ offset: 0 });
            }
        }
    }

    monthDiff(d1, d2) {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
    }

    onCheckExpiredDate(expireDate) {
        const today = new Date();
        const d = new Date(expireDate);
        let expiredMonth = (today.getFullYear() - d.getFullYear()) * 12;
        expiredMonth -= d.getMonth() + 1;
        expiredMonth += today.getMonth();
        return expiredMonth <= 0 ? 0 : expiredMonth;
    }

    onCloseDialog() {
        this.dialogRef.close(true);
    }

    getRowClass(row) {
        return {
            'consultation-color-status-incompleted': row.isCourseInCompleted,
            'consultation-color-status-expired': (!row.monthCoverLeft && !row.isCourseInCompleted),
            'consultation-color-status-remain': (row.monthCoverLeft && !row.isCourseInCompleted)
        };
    }

    getCellClass({ row, column, value }) {
        return {
            'text-right': column['prop'] === 'vaccines'
        };
    }
}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/vaccination/record-vaccination-popup.component.ts